import React from "react";
import { Route, Routes } from "react-router-dom";
import { SrmAuthenticationContextProvider } from "../../components/srm-blue-returns/srm-sso-authentication/srm-authentication-context-provider";
import { SrmBlueReturnDetails } from "../../components/srm-blue-returns/srm-blue-return-details/srm-blue-return-details";
import { SrmBlueReturnsLayout } from "../../components/srm-blue-returns/srm-blue-returns-layout/srm-blue-returns-layout";
import { UserSessionContextProvider } from "../../../common/context/application-context/user-session-context-provider";
import { SrmSsoPassThruHttpClientContextProvider } from "../../components/srm-blue-returns/srm-sso-authentication/srm-sso-pass-thru-http-client-context-provider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers";

export const SrmBlueReturnsRouter = () => {
    return <SrmAuthenticationContextProvider>
            <UserSessionContextProvider>
                <SrmSsoPassThruHttpClientContextProvider>
                    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={"pl"}>
                    <SrmBlueReturnsLayout>
                        <Routes>
                            <Route path="/details/:id" element={<SrmBlueReturnDetails />} />
                        </Routes>
                    </SrmBlueReturnsLayout>
                    </LocalizationProvider>
                </SrmSsoPassThruHttpClientContextProvider>
            </UserSessionContextProvider>
        </SrmAuthenticationContextProvider>;
};
